import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type Props = {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  /** Подпись кнопки подтверждения. По умолчанию Delete — диалог исторически использовался для удаления */
  confirmLabel?: string;
};

export const ConfirmDialog = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  isLoading = false,
  confirmLabel = 'Delete',
}: Props) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <LoadingButton onClick={onConfirm} color="error" variant="contained" loading={isLoading}>
          {confirmLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
